import React from 'react';
import PropTypes from 'prop-types';

import './DiscoverOverlayStack.scss';

const buildClassName = (base, extra) => (extra ? `${base} ${extra}` : base);

export default function DiscoverOverlayStack({
    children = null,
    className = '',
    ariaLabel = 'Map status updates',
}) {
    const content = React.Children.toArray(children).filter(Boolean);
    if (content.length === 0) {
        return null;
    }

    return (
        <div
            className={buildClassName('discover-overlay__stack', className)}
            aria-live="polite"
            aria-label={ariaLabel}
        >
            {content}
        </div>
    );
}

DiscoverOverlayStack.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    ariaLabel: PropTypes.string,
};
